import {environment} from '@env/environment';

export const LABELS_MAP = new Map([
    ['Guid', environment.customer.guidTitle],
    ['Given Name', 'First Name'],
    ['Family Name', 'Last Name'],
    ['Section Number', 'Class Number'],
    ['Section Name', 'Class Name'],
    ['Section Id', 'Class Id'],
    ['Id', 'SIS Id']
]);
